import { TResponse } from '../basis/types/tresponse';
import { axiosGet, axiosPost } from '../utils/axios';
import config from '../basis/config.json';
import { TField } from '../basis/types/tfield';
import { TPerson } from '../basis/types/database/tperson';

// 用户登录
export const userLogin = async (data: { loginName: string; nonce: string; password: string }) => {
  const resp = await axiosPost<TResponse.Result<TPerson.User>>(`/mgr/v1/auth/login`, {
    ...data,
    clientType: config.clientId,
    grantType: TField.GRANT_TYPE_PASSWORD,
  });

  return resp;
};

// 用户退出登录
export const userExitLogin = async () => {
  const resp = await axiosPost<TResponse.Result>(`/mgr/v1/auth/logout`);

  return resp;
};

// 获取当前用户信息
export const userCurrentInfo = async () => {
  const resp = await axiosGet<TResponse.Result<TPerson.User>>(`/mgr/v1/users/current_user`);

  return resp;
};

// 获取会议用户信息
export const getUserInfo = async (data: { userId: string }) => {
  const resp = await axiosGet<TResponse.Result<TPerson.User>>(`/mgr/v1/users/userId/${data.userId}`);

  return resp;
};
